import { MessagePayload } from '_api/types';

const DefaultNewMessage: MessagePayload = {
  receiverId: 0,
  message: '',
  type: 'TEXT',
};

export default DefaultNewMessage;
